import React, { useState, useEffect } from "react";
import styles from "./DataFilter.module.css";
import { IoMdClose } from "react-icons/io"; // close icon

// import DataFilter from "../../components/DataFilter/DataFilter";

const DataFilter = ({
  onChange = () => {},
  initialFilters = [],
  placeholder = "",
}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    onChange(filters);
  }, [filters, onChange]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      const newFilter = inputValue.trim();
      if (!filters.includes(newFilter)) {
        setFilters([...filters, newFilter]);
      }
      setInputValue("");
    }
  };
  

  const removeFilter = (indexToRemove) => {
    setFilters(filters.filter((_, i) => i !== indexToRemove));
  };

  return (
    <div className={styles.scrollContainer}>
      <div className={styles.container}>
        {filters.map((filter, index) => (
          <div key={index} className={styles.tag}>
            <span>{filter}</span>
            <IoMdClose
              className={styles.close}
              onClick={() => removeFilter(index)}
            />
          </div>
        ))}
        <input
          type="text"
          placeholder={placeholder}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          className={styles.input}
        />
      </div>
    </div>
  );
};

export default DataFilter;
